import applyArticleDistributionChannelPresetData from "../articles/data/applyArticleDistributionChannelPresetData";

import filterEligibleDistributionChannels from "./utils/filterEligibleDistributionChannels";
import getPublisherDistributionPresets from "./utils/getPublisherDistributionPresets";

export default function getArticleDistributionPresets({ article, publisher, channels }) {
	if (!article || !publisher || !channels) {
		return {};
	}

	const presets = getPublisherDistributionPresets({ article, publisher });
	const eligibleChannels = filterEligibleDistributionChannels({ article, channels });

	// merge with article channels (if publisher has disabled a channel we should still keep on on articles that had it before)
	const articleChannels = Object.keys(article.channels || {});

	const presetChannelIds = [...new Set([...(presets?.map(({ channel }) => channel.id) || []), ...articleChannels])];

	const presetChannels = eligibleChannels
		.filter((channel) => presetChannelIds.includes(channel.id))
		.sort(
			(a, b) =>
				!article.channelIds?.includes(a.id) - !article.channelIds?.includes(b.id) ||
				a.name.localeCompare(b.name),
		);

	const enabledChannels = presetChannels.filter((channel) => article.channelIds?.includes(channel.id));

	const applyPresets = () => {
		return presetChannels.reduce((acc, channel) => {
			const preset = presets.find((preset) => preset.channel.id === channel.id);

			return {
				...acc,
				[channel.id]: applyArticleDistributionChannelPresetData({ article, channel, preset }),
			};
		}, {});
	};

	return { presets, eligibleChannels, presetChannelIds, presetChannels, enabledChannels, applyPresets };
}
